import { colors } from "../../constants/colors";
import { FONT_SIZES } from "../../constants/fontSizes";

const overallScoreColor = colors.blue_green.DEFAULT;

export const columnDescriptions = {
  "Name Candidate": `The proposed trademark name evaluations that were either AI generated or provided by the user. `,
  "Overall Score": `Aggregate risk score based on all factors (1-5 scale, higher means more risk).
    The score favors Name Similarity. For example, if two names have the same or Similar Name,
    then the Overall Score will always reflect the risk even if the other factors are low.`,
  "Industry Similarity": `Similarity to existing trademarks in your industry (1-5 scale higher means more similarity industry).
    If a name is similar to an existing trademark, it is critical
    to differentiate in the industry to avoid product confusion and legal disputes.`,
  "Legal Activity": `Amount of legal activity related to trademark owners (1-5 scale higher means more activity).
    This is derived from the USPTO database and the amount of legal activity engaged in by the trademark owner.
    Obviously, the more legally active a trademark owner is, the more careful you should decide.`,
  "Name Similarity": `Similarity to existing trademark names (1-5 scale higher is more similar).`,
  "Existing Trademarks": `Links to similar existing trademarks in the USPTO database`,
  "Matched Trademark": `This trademark was matched to the candidate name during trademark keyword search.`,
  "Serial Number": `USPTO application or registration number`,
  "Trademark Product Description": `Context included in the USPTO database by trademark owners
    to describe their product/services and the market they serve.`,
};

export const styles = {
  reportViewWidth: {
    limitMobileWidth: "600px",
    limitSummaryWidth: "400px",
    limitDomainWidth: "400px",
  },
  container: {
    width: "100%",
    paddingBottom: 40,
  },
  tableContainer: {
    margin: "2px",
    width: "100%",
    marginTop: "50px",
  },
  table: {
    width: "100%",
    tableLayout: "fixed",
  },
  cell: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 0,
    fontSize: FONT_SIZES.TABLE_CELL,
    padding: "8px",
    lineHeight: "1.2",
  },
  mobileCell: {
    height: "40px",
    padding: "4px 8px",
    fontSize: FONT_SIZES.TABLE_CELL.xs,
  },
  headerCell: {
    whiteSpace: "normal",
    fontSize: FONT_SIZES.TABLE_COLUMN,
    padding: "8px 16px",
    marginBottom: "1px",
  },
  mobileHeaderCell: {
    writingMode: "vertical-rl",
    transform: "rotate(230deg)",
    maxHeight: "100px",
    padding: "15px 16px",
    verticalAlign: "center",
    textAlign: "center",
    lineHeight: "1.2",
    letterSpacing: "-0.5px",
    fontSize: FONT_SIZES.TABLE_COLUMN,
  },
  columnHeader: {
    fontWeight: "bold",
    cursor: "help",
    fontSize: FONT_SIZES.TEXT_HINT,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  alert: {
    margin: "10px 0",
  },
  dataTable: {
    marginBottom: "200px",
  },
  tooltipText: {
    cursor: "pointer",
    display: "inline-block",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: FONT_SIZES.TEXT_HINT,
  },
  accordion: {
    marginBottom: "2px",
    marginTop: "2px",
  },
  accordionTitle: {
    textAlign: "center",
    width: "100%",
    fontSize: FONT_SIZES.SUBTITLE,
  },
  reportTitle: {
    paddingBottom: 0,
    paddingTop: 2,
    textAlign: "center",
    fontSize: FONT_SIZES.SUBTITLE,
  },
  checkboxContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  checkboxHeaderContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "2px",
    padding: "2px",
    gap: "4px",
    width: "100%",
  },
  copyButtonContainer: {
    marginBottom: 2,
  },
  paper: {
    marginBottom: 3,
  },
  paperTitle: {
    padding: 2,
  },
  legendContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  legendColorBox: {
    width: 20,
    height: 20,
    border: "1px solid #999",
  },
  legendText: {
    fontSize: FONT_SIZES.TEXT_HINT,
  },
  lowRiskColor: {
    backgroundColor: colors.blue_green[500],
  },
  mediumRiskColor: {
    backgroundColor: colors.ut_orange[500],
  },
  highRiskColor: {
    backgroundColor: colors.sienna[500],
  },
  footnote: {
    fontSize: FONT_SIZES.TEXT_HINT,
    color: "#666",
    marginTop: "8px",
    fontStyle: "italic",
  },
  printStyles: {
    accordion: {
      "@media print": {
        "& .MuiTypography-root": {
          fontSize: "0.875rem",
        },
        "& .MuiTableCell-root": {
          fontSize: "0.875rem",
          padding: "4px 8px",
        },
        "& .MuiTableRow-root": {
          "& td:last-child": {
            whiteSpace: "normal",
            wordBreak: "break-word",
            minWidth: "0",
            maxWidth: "none",
            width: "auto",
            overflow: "visible",
          },
        },
        "& .MuiTable-root": {
          tableLayout: "auto",
        },
        ".vibe-truncate": { display: "none !important" },
        ".vibe-full": { display: "inline !important" },
      },
    },
    dataTable: {
      "@media print": {
        "& .MuiTableCell-root": {
          fontSize: "0.875rem",
          padding: "4px 8px",
        },
        "& .MuiTableRow-root": {
          "& td:last-child": {
            whiteSpace: "normal",
            wordBreak: "break-word",
            minWidth: "0",
            maxWidth: "none",
            width: "auto",
            overflow: "visible",
          },
        },
        "& .MuiTable-root": {
          tableLayout: "auto",
        },
        ".vibe-truncate": { display: "none !important" },
        ".vibe-full": { display: "inline !important" },
      },
    },
    "@media print": {
      ".all-domains-truncate": { display: "none !important" },
      ".all-domains-full": { display: "inline !important" },
      ".trademark-desc-truncate": { display: "none !important" },
      ".trademark-desc-full": { display: "inline !important" },
    },
  },
  ".all-domains-full": { display: "none" },
  ".trademark-desc-full": { display: "none" },
};

// Hide the full version of Vibe text, all-domains, and trademark description on screen, show only when printing
if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.innerHTML = `
    .vibe-full, .all-domains-full, .trademark-desc-full { display: none !important; }
    @media print {
      .vibe-truncate, .all-domains-truncate, .trademark-desc-truncate { display: none !important; }
      .vibe-full, .all-domains-full, .trademark-desc-full { display: inline !important; }
      .MuiTableCell-root { white-space: normal !important; word-break: break-word !important; }
    }
  `;
  document.head.appendChild(style);
}

export const getScoreColor = (score) => {
  if (score >= 4) return styles.highRiskColor; // Red
  if (score >= 3) return styles.mediumRiskColor; // Orange
  return styles.lowRiskColor; // Green
};

export const getDomainAvailabilityColor = (score) => {
  if (score <= 1) return styles.highRiskColor; // Red - Low Availability
  if (score <= 3) return styles.mediumRiskColor; // Orange - Medium Availability
  return styles.lowRiskColor; // Green - High Availability
};

export const getDetailedRowColor = (row) => {
  const industryScore =
    parseFloat(row["Industry Similarity"] || row.industry_similarity_score) ||
    0;
  const legalScore =
    parseFloat(row["Legal Activity"] || row.legal_activity_score) || 0;
  const nameScore =
    parseFloat(row["Name Similarity"] || row.name_similarity_score) || 0;
  const maxScore = Math.max(industryScore, legalScore, nameScore);
  return getScoreColor(maxScore);
};

export const getSummaryRowColor = (row) => {
  const score = parseFloat(row.score) || 0;
  return getScoreColor(score);
};

export const isNumericColumn = (columnId) => {
  const numericColumns = [
    "score",
    "industry_similarity_score",
    "legal_activity_score",
    "name_similarity_score",
    "Industry Similarity",
    "Legal Activity",
    "Name Similarity",
    "domain_availability_score",
    "seo_potential",
    "clarity_readability",
    "brand_strength",
    "functional_alignment",
    "brand_appeal",
    "memorability",
    "relevance",
    "uniqueness",
    "seo_searchability",
    "emotional_resonance",
  ];
  return numericColumns.includes(columnId);
};
